import React, { Component } from "react";
import {
  alert,
  profile,
  toFixed,
  format_date,
  GET,
  POST,
  loading,
  params,
  MonthPicker,
  Select,
  Navbar,
  XLSX,
  saveAs,
} from "../../components/CustomComponent.js";
export default class Settlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_date: format_date(new Date(), "yyyy-mm", "en"),
      filter_broker: "",
      filter_currency: "THB",
      date: "",

      loaded: false,
      data: [],
      count: 10,
      data_broker: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(0)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker;
    let [result_broker] = await Promise.all([
      GET("v1/admin/brokers/options", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        gateway: e.gateway_deposits,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async (page) => {
    let data, count;

    const { filter_date, filter_currency, filter_broker } = this.state;
    loading(true);
    let _date = new Date(filter_date);
    let _date_start = format_date(
      new Date(_date.getFullYear(), _date.getMonth(), 1),
      "yyyy-MM-dd",
      "en"
    );
    let _date_end = format_date(
      new Date(_date.getFullYear(), _date.getMonth() + 1, 0),
      "yyyy-MM-dd",
      "en"
    );

    let [result] = await Promise.all([
      GET("profits/settlements", {
        page_size: 100000,
        page: 0,
        data_search: "",
        start_date: filter_date
          ? format_date(_date_start, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_date ? format_date(_date_end, "yyyy-mm-dd", "en") : "",
        currency: filter_currency || "",
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      loaded: true,
      data: data?.filter(
        (e) => !filter_broker || e.broker?.uid.includes(filter_broker || "")
      ),
      count,
    });
    loading(false);
  };

  ExportCSV = async () => {
    const { data, filter_date } = this.state;
    // EXPORT EXCEL
    const json_data = data.map((item) => ({
      Date: format_date(item.date),
      Broker: item.broker?.name_en || item.broker?.name_th || "",
      Previous: item.previous ? toFixed(item.previous, 2) : "00.00",
      Deposit: item.total_deposits ? toFixed(item.total_deposits, 2) : "00.00",
      Withdrawal: item.total_withdrawals ? toFixed(item.total_withdrawals, 2) : "00.00",
      Balance: item.balance ? toFixed(item.balance, 2) : "00.00",
    }));
    // 1. Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(json_data);

    // 2. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 3. Write the workbook to binary buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // 4. Save to file
    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(file, `settlements-${format_date(filter_date, "mm/yy", "en")}.xlsx`);
  };
  RecalculateSettlement = async () => {
    const { filter_broker, filter_currency, data_broker } = this.state;
    const selectedBrokerName =
      data_broker?.find((item) => item.value === filter_broker)?.label ||
      filter_broker;

    if (!filter_broker) {
      alert(
        "",
        "warning",
        "Warning",
        "Select Broker before using Recalc"
      );
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm Recalc",
        `${selectedBrokerName} - ${filter_currency}`,
        "confirm",
        "cancel"
      )
    ) {

      loading(true);
      const result = await POST("v1/admin/settlements/recalc", {
        broker_uid: filter_broker,
        currency: filter_currency,
      });
      if (result?.status) {
        alert("", "success", "Success", "Recalculate settlement completed");
        await this.Get(1);
      }
      loading(false);
    }
  };
  render() {
    const {
      filter_date,
      filter_broker,
      filter_currency,
      loaded,
      data,
      data_broker,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const isSuper = profile.user_type === "super_user";

    // ---- presentation-only helpers (ข้อมูลและ logic การดึงไม่เปลี่ยน) ----
    const num = (v) => Number(v) || 0;
    const cell = (v) => (v ? toFixed(v, 2) : "00.00");
    const total = (key) => rows.reduce((acc, e) => acc + num(e[key]), 0);
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const selectedDate = filter_date ? new Date(filter_date) : null;
    const heroMonth =
      selectedDate && !isNaN(selectedDate)
        ? monthNames[selectedDate.getMonth()].slice(0, 3).toUpperCase()
        : "—";
    const heroYear =
      selectedDate && !isNaN(selectedDate) ? selectedDate.getFullYear() : "";
    const currency = global.currency?.find(
      (c) => c.currency_code === filter_currency
    );
    const selectedBrokerLabel = data_broker?.find(
      (b) => b.value === filter_broker
    )?.label;

    const sumDeposits = total("total_deposits");
    const sumWithdrawals = total("total_withdrawals");
    // ยอดคงเหลือปิดงวด = balance ของแถวล่าสุดของแต่ละ broker ที่แสดงอยู่
    const latestByBroker = {};
    rows.forEach((e) => {
      const key = e.broker?.uid || e.broker?.name_en || "-";
      const t = new Date(e.date).getTime();
      if (!latestByBroker[key] || t > latestByBroker[key].t) {
        latestByBroker[key] = { t, balance: num(e.balance) };
      }
    });
    const closingBalance = Object.values(latestByBroker).reduce(
      (acc, e) => acc + e.balance,
      0
    );

    return (
      <div className="w-100 min-vh-100 premium-report">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* ===== Hero ===== */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Settlement Report</div>
                <div className="ar-title">Settlement Reports</div>
                <div className="ar-subtitle">
                  Daily settlement and balance tracking
                </div>
              </div>
              <div className="ar-hero-actions">
                {isSuper && (
                  <button
                    className="ar-btn-ghost settlements.update"
                    onClick={() => this.RecalculateSettlement()}
                  >
                    <span className="icon me-2">{""}</span>Recalc
                  </button>
                )}
                <button
                  className="ar-btn-ghost"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{""}</span>Export CSV
                </button>
                <div className="text-end ms-2">
                <div className="ar-year">
                  {heroMonth}
                  <span className="ar-year-small"> {heroYear}</span>
                </div>
                <div className="ar-year-caption">
                  {selectedBrokerLabel && (
                    <span className="ar-caption-chip ms-2">{selectedBrokerLabel}</span>
                  )}
                </div>
              </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-4">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Broker</span>
                  <Select
                    className="form-control"
                    placeholder="All brokers"
                    options={data_broker}
                    onChange={(e, i) => {
                      this.setState({ filter_broker: e });
                    }}
                    value={filter_broker}
                  />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Month</span>
                  <MonthPicker
                    className="form-control"
                    placeholder="Month..."
                    onChange={(e) => {
                      this.setState({ filter_date: e });
                    }}
                    value={filter_date}
                  />
                </div>
              <div className="ar-toolbar-actions">
                <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                  <span className="icon me-2">{""}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_date: format_date(new Date(), "yyyy-mm", "en"),
                        filter_broker: "",
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
              </div>
              </div>
              <div className="ar-filter-foot">
                <div className="d-flex align-items-center gap-2">
                  {global.currency?.map((item) => (
                    <button
                      key={item.currency_code}
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ===== Table ===== */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">Daily Settlements</div>
                <div className="ar-table-caption">
                  {heroMonth} {heroYear} · {filter_currency} ·{" "}
                  {selectedBrokerLabel ? selectedBrokerLabel : "All brokers"} ·{" "}
                  {rows.length} row{rows.length === 1 ? "" : "s"}
                </div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span><i className="ar-legend-dot ar-legend-dep"></i>Deposit</span>
                <span><i className="ar-legend-dot ar-legend-wd"></i>Withdrawal</span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table">
                <thead>
                  <tr>
                    <td className="text-nowrap">Date</td>
                    <td className="text-nowrap ar-sticky">Broker</td>
                    <td className="text-nowrap text-end">Previous</td>
                    <td className="text-nowrap text-end ar-group-start">Deposit</td>
                    <td className="text-nowrap text-end">Withdrawal</td>
                    <td className="text-nowrap text-end ar-group-start ar-head-profit">Balance</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const d = new Date(item.date);
                    const day = isNaN(d) ? "" : String(d.getDate()).padStart(2, "0");
                    return (
                      <tr key={`array-${index}`}>
                        <td data-label="Date" className="text-nowrap">
                          <div className="ar-month-badge">
                            <span>{day}</span>
                            {format_date(item.date)}
                          </div>
                        </td>
                        <td data-label="Broker" className="text-nowrap ar-sticky ar-broker">
                          {item.broker?.name_en || item.broker?.name_th || ""}
                        </td>
                        <td data-label="Previous" className="text-nowrap text-end ar-muted">
                          {cell(item.previous)}
                        </td>
                        <td
                          data-label="Deposit"
                          className={`text-nowrap text-end ar-group-start ${
                            num(item.total_deposits) > 0 ? "ar-dep-profit" : "ar-zero"
                          }`}
                        >
                          {cell(item.total_deposits)}
                        </td>
                        <td
                          data-label="Withdrawal"
                          className={`text-nowrap text-end ${
                            num(item.total_withdrawals) > 0 ? "ar-wd-profit" : "ar-zero"
                          }`}
                        >
                          {cell(item.total_withdrawals)}
                        </td>
                        <td
                          data-label="Balance"
                          className={`text-nowrap text-end ar-group-start fw-bold ${
                            num(item.balance) < 0 ? "ar-neg" : ""
                          }`}
                        >
                          {cell(item.balance)}
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={6} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          No data for {heroMonth} {heroYear} · {filter_currency}
                          {selectedBrokerLabel ? ` · ${selectedBrokerLabel}` : ""}
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.length > 0 && (
                    <tr className="ar-total">
                      <td></td>
                      <td className="ar-sticky">
                        <div className="ar-month-badge">
                          <span className="ar-month-badge-total">Σ</span>
                          TOTAL
                        </div>
                      </td>
                      <td className="text-end ar-muted">—</td>
                      <td data-label="Deposit" className="text-end ar-group-start">
                        {toFixed(sumDeposits, 2)}
                      </td>
                      <td data-label="Withdrawal" className="text-end">
                        {toFixed(sumWithdrawals, 2)}
                      </td>
                      <td
                        data-label="Balance"
                        className={`text-end ar-group-start ${closingBalance < 0 ? "ar-neg" : ""}`}
                        title="Closing balance: latest row per broker"
                      >
                        {toFixed(closingBalance, 2)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
